import './QdAddToGoogleCalendar.scss';
import template from './QdAddToGoogleCalendar.vhtml';

export default {
	name: 'QdAddToGoogleCalendar',
	template: template,
	props: {
		title: {
			type: String,
			required: true,
		},
		details: {
			type: String,
			default: '',
		},
		locations: {
			type: String,
			required: true,
		},
		startDate: {
			type: String,
			required: true,			
		},
		endDate: {
			type: String,
			required: true,			
		}
	},
	data: () => ({}),
	computed: {
		formatedTitle: vm => encodeURIComponent(vm.title),
		formatedDetails: vm => encodeURIComponent(vm.details),
		formatedlocations: vm => encodeURIComponent(vm.locations),
		calendarUrl: vm => `https://www.google.com/calendar/event?action=TEMPLATE&trp=false&text=${vm.formatedTitle}&location=${vm.formatedlocations}&details=${vm.formatedDetails}&dates=${vm.startDate}/${vm.endDate}`,
	},
	methods: {},
};
